import { gtagEnabled } from './index'
import { formatMedusaPrice } from '../formatMedusaPrice'
import { LineItem } from '@medusajs/medusa'

export const trackRemoveFromCartLineItem = (item: LineItem, quantity: number, price?: number) => {
    if (gtagEnabled()) {
        gtag('event', 'remove_from_cart', {
            currency: 'EUR',
            value: formatMedusaPrice(item.unit_price),
            items: [
                {
                    item_name: item.title,
                    item_id: item.variant_id,
                    quantity: quantity,
                    price: price,
                },
            ],
        })
    }
}
